enum SendEmailTypeEnum {
  CodigoAcesso = 'CA',
  BoletoContrato = 'EBCPN',
  BoletoPagamentoAvulso = 'EBPAPN',
  BoletoRenegociacao = 'EBRPN',
  BoletoContratoAcordo = 'EBCAPN'
}

export default SendEmailTypeEnum
